import Button from '@murphy-frontend/web-core/components/Button';
import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { Tooltip } from 'react-tooltip';

interface Buttons {
    text: string,
    type: string,
    onClick?: () => void
}
interface Props {
    id: string
    title: string
    body1: string
    body2?: string
    place?: string
    buttons: Buttons[]
}

const styles = {
    container: {
        width: "20rem",
        margin: '16px',
        backgroundColor: "white",
        display: 'flex',
        flexDirection: 'column'
    },
    title: {
        color: '#00726C',
        fontSize: 16,
        fontWeight: 'bold'
    },
    body: {
        color: '#626262',
        fontSize: 14,
        marginTop: 10
    }
}
const CustomTooltip = forwardRef(({ id, title, body1, body2, buttons, place = 'right-end' }: Props, ref) => {

    const tooltipRef = useRef(null);
    useImperativeHandle(ref, () => ({
        openTooltip() {
            tooltipRef.current.open();
        },
        closeTooltip() {
            tooltipRef.current.close();
        }
    }));

    return (
        <Tooltip
            ref={tooltipRef}
            style={{ borderRadius: '20px' }}
            className="custom-tooltip"
            clickable
            variant="light"
            place={place}
            offset={20}
            id={id}
        >
            <div
                style={styles.container}
            >
                <label style={styles.title}>{title}</label>
                <label style={styles.body}>{body1}</label>
                <label style={styles.body}>{body2}</label>
                <div style={{ display: 'flex', flexDirection: 'row', marginTop: 20, alignItems: 'center' }}>
                    {
                        buttons.map(button =>
                            button?.type === 'label' ? <label style={{ textDecorationLine: 'underline', color: '#7F7F7F', cursor: 'pointer', marginRight: 20 }} onClick={() => { tooltipRef.current.close(); if (button.onClick) {button.onClick()} }}>{button.text}</label>
                                : <Button buttonStyle='btn--primary' onClick={() => { tooltipRef.current.close(); if (button.onClick) {button.onClick()} }}>
                                    {button.text}
                                </Button>
                        )
                    }
                </div>
            </div>
        </Tooltip>
    )
})

export default CustomTooltip